import Carousel from "nuka-carousel";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import SocialCard from "../SocialCard";
import getNumberOfCards from "./getCards";
import useMediaQueries from "@hooks/useMediaQueries";
import { CarouselSocialProofType } from "../types/SocialProof";
import ArrowLeft from "../SVGs/ArrowLeft";
import ArrowRightDots from "../SVGs/ArrowRightDots";
import useWindowSize from "@hooks/useWindowSize";

const CarouselSocialProof: React.FC<CarouselSocialProofType> = ({
  cards,
  builderBlock,
  BuilderBlocksComponent,
  onClick,
}) => {
  const { isDesktop } = useMediaQueries();
  const { width: windowWidth } = useWindowSize();

  const [carouselItem, setCarouselItem] = useState(0);
  const [activeCarouselItem, setActiveCarouselItem] = useState<number | null>(
    null
  );
  const [slidesToShow, setSlidesToShow] = useState(3);

  const ref = useRef<HTMLDivElement>(null);

  const updateSlidesToShow = useCallback(() => {
    const numCards = getNumberOfCards(isDesktop);
    setSlidesToShow(numCards);
  }, [isDesktop]);

  useEffect(() => {
    updateSlidesToShow();
    window.addEventListener("resize", updateSlidesToShow);
    return () => {
      window.removeEventListener("resize", updateSlidesToShow);
    };
  }, [updateSlidesToShow]);

  const cardsList = useMemo(() => cards?.reverse(), [cards]);

  return (
    <div ref={ref}>
      <Carousel
        cellSpacing={24}
        slideIndex={carouselItem}
        renderCenterCenterControls={null}
        renderBottomRightControls={null}
        renderCenterLeftControls={null}
        renderCenterRightControls={null}
        renderBottomCenterControls={({ previousSlide, nextSlide }) =>
          windowWidth > 1023 ? (
            <div className="social--prof__arrows">
              <button
                type="button"
                className="social--proof__arrow-button"
                onClick={previousSlide}
                aria-label="Left Arrow"
              >
                <ArrowLeft />
              </button>
              <button
                type="button"
                className="social--proof__arrow-button"
                onClick={nextSlide}
                aria-label="Right Arrow"
              >
                <ArrowRightDots />
              </button>
            </div>
          ) : null
        }
        dragging
        adaptiveHeight
        slidesToShow={slidesToShow}
        beforeSlide={(_, b) => {
          setCarouselItem(b);
        }}
        className="social--prof--carousel"
        wrapAround
        style={{ height: "inherit" }}
      >
        {cardsList?.map((card, key) =>
          card?.disableTestimonial ? (
            <div className="social--prof__card--block" key={key}>
              <BuilderBlocksComponent
                child
                parentElementId={builderBlock?.id}
                dataPath={`component.options.cards.${key}.cardContent`}
                blocks={
                  builderBlock?.component?.options?.cards?.[key]?.cardContent
                }
              />
            </div>
          ) : (
            <SocialCard
              key={key}
              backgroundImage={card?.image}
              customMouseEnter={() => setActiveCarouselItem(key)}
              customMouseLeave={() => setActiveCarouselItem(null)}
              quote={card?.quote}
              title={card?.cardTitle}
              ctaCopy={card?.ctaCopy}
              ctaLink={card?.ctaLink?.value?.data?.url}
              customClass={`social--prof__card--index ${activeCarouselItem === key && "social--prof__card--active"
                }`}
              ctaUrl={card?.ctaUrl}
              onClick={onClick}
            />
          )
        )}
      </Carousel>
    </div>
  );
};

export default CarouselSocialProof;
